import React from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import GridBlock from './GridBlock';

const style = theme => ({
	root: {

	},
	title: {
		fontWeight: theme.typography.fontWeightBold,
	},
})

function TitledComponent({
	classes,
	children,
	title,
	className,
	required,
	labelClassName,
	additionalElement,
	componentRef
}) {

	return (
		<div ref={componentRef} className={className + ' ' + classes.root}>
			<GridBlock justify="space-between">
				<Typography
					variant='body1'
					className={clsx(
						classes.title,
						labelClassName,
					)}
				>
					{title}{required && '*'}
				</Typography>
				{additionalElement}
			</GridBlock>
			{children}
		</div>
	)
}

TitledComponent.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.any,
	title: PropTypes.string,
}

TitledComponent.defaultProps = {
}

export default withStyles(style)(TitledComponent);